import * as React from "react";

import {
  snapshotCollectionRoute,
  useGetContractFamilyPipelineSourceLinkQuery,
  usePublishContractFamilyPipelineMutation,
} from "@/api/contract-family-pipeline";
import { Button } from "@/components/ui/button";

import { getPipelineErrorMessage } from "./pipelineErrors";

export const AddToMasterCollectionAction = ({ runId, targetUrl }: { runId: string; targetUrl: string | null }) => {
  const [publish, state] = usePublishContractFamilyPipelineMutation();
  const source = useGetContractFamilyPipelineSourceLinkQuery(runId);
  const sourceUrl = source.data ? snapshotCollectionRoute(source.data.template_id, source.data.collection_id) : null;
  const key = React.useRef(crypto.randomUUID());
  const [result, setResult] = React.useState<{ inserted_count: number; skipped_duplicate_count: number } | null>(null);
  const submit = async () => {
    try {
      setResult(await publish({ runId, idempotencyKey: key.current }).unwrap());
    } catch {
      // RTK Query exposes the bounded API error through state; retain the key for retry.
    }
  };
  const handleSubmit = () => void submit();
  if (result)
    return (
      <div role="status" className="space-y-2">
        <p>
          Added {result.inserted_count}; skipped {result.skipped_duplicate_count} duplicates.
        </p>
        <div className="flex gap-3 text-sm">
          {targetUrl ? (
            <a className="underline" href={targetUrl}>
              Open Family Collection
            </a>
          ) : null}
          {sourceUrl ? (
            <a className="underline" href={sourceUrl}>
              Open source collection
            </a>
          ) : null}
        </div>
      </div>
    );
  return (
    <div>
      <Button disabled={state.isLoading} onClick={handleSubmit}>
        Add to Master Collection
      </Button>
      {state.isError ? (
        <div role="alert" className="mt-2 space-y-2 text-sm text-red-700">
          <p>{getPipelineErrorMessage(state.error)}</p>
          <Button variant="outline" onClick={handleSubmit}>
            Retry
          </Button>
        </div>
      ) : null}
    </div>
  );
};
